import DateFormat from '@voidsolutions/vue-dateformat'

export default defineNuxtPlugin((context) => {
    context.vueApp.use(DateFormat)
})
